import React from 'react';
import PropTypes from 'prop-types';
import { fsvMessages, tocByUseType } from './data/utils';
import { upperCaseFirst } from 'change-case';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import ListingStatus from '../_v2/features/pause-listing/components/ListingStatus';

const DeactivatedListingsPanel = ({ useType, panelClassname = '', spaceId, intl, isDeactivated, isFsv = false }) => {
  const useTypeHash = tocByUseType[useType];
  const description = isFsv ? fsvMessages.description : useTypeHash.description;

  return (
    <div className={`flex middle deactivated-panel listing-panel ${panelClassname}`}>
      <div className="panel-sections use-type-icon">
        <img alt={useTypeHash.icon} className="icon-xl" src={`/web-hosting/assets/images/${useTypeHash.icon}.svg?v=rb`} />
      </div>
      <div className="panel-sections flex-basis-70">
        <div className="deactivated-use-type margin-sm-right heavy">{upperCaseFirst(intl.formatMessage(useTypeHash.title))}</div>
        <div className='deactivated-description'>
          { isDeactivated &&
            <div>
              <ListingStatus status="DEACTIVATED" />
            </div>
          }
          <div className="deactivated-use-type text-gray-600">
            {intl.formatMessage(description)}
          </div>
        </div>
      </div>
      <div className="panel-sections enable-button">
        <a href={`/your-space/${spaceId}/activate-listings`} className="btn btn-gray-outline btn-outlined-light btn-block">
          <FormattedMessage id="pause.button.activate" defaultMessage="Activate" />
        </a>
      </div>
    </div>
  );
};

DeactivatedListingsPanel.propTypes = {
  useType: PropTypes.string.isRequired,
  panelClassname: PropTypes.string,
  spaceId: PropTypes.string.isRequired,
  isDeactivated: PropTypes.bool,
  isFsv: PropTypes.bool,
  intl: intlShape
};

export default injectIntl(DeactivatedListingsPanel);
